import React, { useContext, useEffect, useState } from 'react';
import CashNoticeComponent from '../CashNoticeComponent';
import CashZoneComponent from '../CashZoneComponent';
import CashButton from '../CashButton';
import CashTab from '../CashTab';
import CashTableComponent from '../CashTableComponent';
import LoginContext from '../../context';
import axios from 'axios';
const noticeList = [
  '※ 입금순서',
  '<span class="text-crimson">계좌요청 &gt; 입금 &gt; 입금신청 </span> 순으로 해주시면 가장 신속하게 처리됩니다 (순서를 지키지 않으시면 입금처리되지않습니다)',
  '※ 충전은 <span class="text-crimson">만원 단위</span>만 가능하시며, <span class="text-crimson">만원 미만 단위</span> 입금 시 <span class="text-crimson">만원 단위 맞춰서 추가입금 하셔야 처리 가능합니다.</span>',
  '※<span class="text-crimson"> 허위충전 </span> 시 경고없이 제재 됩니다.',
  '※ 회원님의 안전을 위해 <span class="text-crimson">천만원 이상</span> <span class="text-crimson">충전시 900만원 밑으로 여러번 입금 후</span> 충전신청을 한번에 눌러주셔야 합니다.',
  '※ 입금신청 후 최대 5분이내 입금이 완료되지 않을 경우 자동 취소 되며, <span class="text-crimson">반복적인 허위 입금 신청 시 경고 없이 모든 이벤트 참여 자격 박탈</span>됩니다.',
  '※ 회원가입 시 기재된<span class="text-crimson"> 본인 명의 계좌만 입금이 가능 </span>합니다.',
  '※ 최소 충전 금액은 <span class="text-crimson"> 10,000 원 </span> 입니다',
];
const Cash1Component = () => {
  const { token } = useContext(LoginContext);
  const [deposits, setDeposits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [amount, setAmount] = useState(0);
  const [name, setName] = useState('');
  const [events, setEvents] = useState([]);
  const pageSize = 10;
  const fetchPromotions = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/transactions/promotions/available`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token?.token}`,
          },
        }
      );
      const data = await res.json();
      setEvents(data.results);
    } catch (error) {
      console.error('Error fetching promotions:', error);
    }
  };

  useEffect(() => {
    if (token?.token) {
      fetchPromotions();
    }
  }, [token]);

  const fetchDeposits = async (currentPage) => {
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/transactions/deposits/my-requests?page=${currentPage}&size=${pageSize}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token?.token}`,
          },
        }
      );

      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      setDeposits(data.results);
      setTotalPages(data.total_pages > 0 ? data.total_pages : 1);
    } catch (error) {
      console.error('Error fetching deposits:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (token?.token) {
      fetchDeposits(currentPage);
    }
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleAmountClick = (label, value) => {
    if (label === '정정') {
      setAmount(0);
      return;
    }

    // setAmount(prev => prev + value);
    setAmount(value);
  };
  const handleDepositRequest = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/transactions/deposits/request`,
        {
          amount: parseInt(amount).toString(),
          depositor_name: name,
        },
        {
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token?.token}`,
          },
        }
      );

      // console.log('Deposit request successful:', response.data);
      setAmount(0);
      await fetchDeposits(currentPage);
      alert('충전신청이 완료되었습니다!');
    } catch (error) {
      console.error('Deposit request failed:', error);
      alert('충전신청에 실패했습니다.');
    }
  };

  return (
    <>
      <div className="pb-[100px] lg:pb-0">
        <CashNoticeComponent
          titleMobile="충전신청전 반드시 확인해 주세요."
          titleDesktop="충전방법"
          notices={noticeList}
        />
        <CashZoneComponent
          handleAmountClick={handleAmountClick}
          amount={amount}
          setAmount={setAmount}
          handleDepositRequest={handleDepositRequest}
          name={name}
          setName={setName}
          events={events}
        />
        <div className="hidden lg:block">
          {/* <CashTab /> */}
          <CashTableComponent
            deposits={deposits}
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Cash1Component;
